/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard/GetBookingStatus
 */
export interface GetBookingStatusRequestBuilder extends BaseRequestBuilder<GetBookingStatusRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<string>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     get(requestConfiguration?: RequestConfiguration<GetBookingStatusRequestBuilderGetQueryParameters> | undefined) : Promise<string | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<GetBookingStatusRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface GetBookingStatusRequestBuilderGetQueryParameters {
    dashboardBookingId?: number;
}
/**
 * Uri template for the request builder.
 */
export const GetBookingStatusRequestBuilderUriTemplate = "{+baseurl}/Dashboard/GetBookingStatus?dashboardBookingId={dashboardBookingId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetBookingStatusRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GetBookingStatusRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
    },
};
/* tslint:enable */
/* eslint-enable */
